import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng';
import { Subscription } from 'rxjs';
import { AppSettings } from '../shared/app.settings';
import { CommonBindingDataService } from '../shared/services/common-binding-data.service';

@Component({
  selector: 'app-manage-shifts',
  templateUrl: './manage-shifts.component.html',
  styleUrls: ['./manage-shifts.component.scss']
})
export class ManageShiftsComponent implements OnInit, OnDestroy {
  items: MenuItem[] = [];
  activeItem: MenuItem;
  manageShiftTabs = AppSettings.MANAGE_SHIFT_TABS;
  globalConfigOS = false;
  private routerSubscription: Subscription;

  constructor(
    private router: Router,
    private commonBindingDataService: CommonBindingDataService
  ) { }

  ngOnInit() {
    this.globalConfigOS = this.commonBindingDataService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.OPEN_SHIFT)?.value;
    // TODO: When we get new key we have to set the if else like this with key to handle tab with access code.
    //      For now on please uncomment the code and continue your development
    if (this.commonBindingDataService.hasAccessPresent('GET_TEAMS_SLOT_GRID_DATA')) {
      this.items.push({
        label: this.commonBindingDataService.getLabel('Team'),
        id: this.manageShiftTabs.TEAM,
        command: () => {
          this.router.navigate(['/manage-shift/week']);
        }
      });
    }
    if (this.commonBindingDataService.hasAccessPresent('GET_TEAM_MEMBERS_GRID_LIST')) {
      this.items.push({
        label: this.commonBindingDataService.getLabel('Team Member'),
        id: this.manageShiftTabs.TEAM_MEMBER,
        command: () => {
          this.router.navigate(['/manage-shift/team-members/week']);
        }
      });
    }
    if (this.globalConfigOS && this.commonBindingDataService.hasAccessPresent('GET_OPEN_SHIFT_GRID_LIST')) {
      this.items.push({
        label: this.commonBindingDataService.getLabel('Manage Open Shifts'),
        id: this.manageShiftTabs.OPEN_SHIFTS,
        routerLink: '/manage-shift/open-shifts',
        command: () => {
          this.router.navigate(['/manage-shift/open-shifts']);
        }
      });
    }

    if (this.commonBindingDataService.hasAccessPresent('GET_SHIFT_PLANING_GRID_LIST')) {
      this.items.push({
        label: this.commonBindingDataService.getLabel('Shift Planning'),
        id: this.manageShiftTabs.SHIFT_PLANNING,
        routerLink: '/manage-shift/shift-planning',
        command: () => {
          this.router.navigate(['/manage-shift/shift-planning']);
        }
      });
    }
    // this.items[0].command();
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showCurrentMenu();
      }
    });
    const currentInc = this;
    setTimeout(() => {
      currentInc.showCurrentMenu();
    });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  findActiveTab(tabKey: string) {
    return this.items.find((tab) => tab.id === tabKey);
  }

  showCurrentMenu() {
    const url = this.router.url.split('?')[0];
    if (url === '/manage-shift') {
      this.openFirstAccessibleTab();
      return;
    }
    const tabKey = this.getTabKeyByUrl(url);
    if (tabKey === undefined) {
      this.activeItem = this.items[0];
      return;
    }
    const accessibleTab = this.findActiveTab(tabKey);
    if (accessibleTab) {
      this.activeItem = accessibleTab;
    } else {
      this.openFirstAccessibleTab();
    }
  }

  private getTabKeyByUrl(url: string) {
    if (url.includes('/team-members')) {
      return this.manageShiftTabs.TEAM_MEMBER;
    }
    if (url.includes('/open-shifts')) {
      return this.manageShiftTabs.OPEN_SHIFTS;
    }
    if (url.includes('/shift-planning')) {
      return this.manageShiftTabs.SHIFT_PLANNING;
    }
    if (url === '/manage-shift/week' || url === '/manage-shift/day') {
      return this.manageShiftTabs.TEAM;
    }
    return undefined;
  }

  private openFirstAccessibleTab() {
    const firstTab = this.items[0];
    if (!firstTab) {
      return;
    }
    this.activeItem = firstTab;
    firstTab.command();
  }

  componentAdded(event: any) {
    const currentInc = this;
    setTimeout(() => {
      currentInc.showCurrentMenu();
    });
  }

  componentRemoved(event: any) {
    const currentInc = this;
    setTimeout(() => {
      currentInc.showCurrentMenu();
    });
  }

}
